import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';
import AccordionSection from './accordionSection';

const OrientationFilter = ({ orientation, updateFilters }) => (
  <AccordionSection title={t("Orientation")}>
    <React.Fragment>
      <div className="flex-row">
        <Checkbox
          size="sm"
          checked={orientation.indexOf('landscape') > -1}
          toggle={() => updateFilters("landscape")}
          label={t("Horizontal")}
        />
        <div className="icon-holder">
          <span className="bff-horizontal-orientation" />
        </div>
      </div>
      <div className="flex-row">
        <Checkbox
          size="sm"
          checked={orientation.indexOf('portrait') > -1}
          toggle={() => updateFilters("portrait")}
          label={t("Vertical")}
        />
        <div className="icon-holder">
          <span className="bff-vertical-orientation" />
        </div>
      </div>
      <div className="flex-row">
        <Checkbox
          size="sm"
          checked={orientation.indexOf('square') > -1}
          toggle={() => updateFilters("square")}
          label={t("Square")}
        />
        <div className="icon-holder">
          <span className="bff-square-orientation" />
        </div>
      </div>
      <div className="flex-row">
        <Checkbox
          size="sm"
          checked={orientation.indexOf('panorama') > -1}
          toggle={() => updateFilters("panorama")}
          label={t("Panoramic")}
        />
        <div className="icon-holder">
          <span className="bff-panoramic-orientation" />
        </div>
      </div>
    </React.Fragment>
  </AccordionSection>
);

OrientationFilter.propTypes = {
  orientation: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateFilters: PropTypes.func.isRequired,
};

export default OrientationFilter;
